import { type ToolCallSummary } from '@/features/types/tools';
import { useTranslation } from 'react-i18next';
import { ToolCallContainer } from './ToolCallContainer';
import { ToolCallContentBox } from './ToolCallContentBox';
import { ToolCallState, useToolCallParser } from './useToolCallParser';

export function DefaultToolCall({ toolCall }: { toolCall: ToolCallSummary }) {
  const { t } = useTranslation('prince');

  const { title } = useToolCallParser<{ [key: string]: unknown }>(toolCall, ({ toolCallState }) => {
    try {
      switch (toolCallState) {
        case ToolCallState.Running:
          return t(`toolCalls.${toolCall.name}.title.whileRunning`, {
            defaultValue: toolCall.name,
          });
        case ToolCallState.Error:
          return t(`toolCalls.${toolCall.name}.title.errors`, { defaultValue: toolCall.name });
        case ToolCallState.Success:
          return t(`toolCalls.${toolCall.name}.title.success`, { defaultValue: toolCall.name });
      }
    } catch {
      return toolCall.name;
    }
  });
  const tabs = [
    {
      id: 'results',
      label: t('toolCalls.results'),
      showLoadingWhileRunning: true,
      content: !toolCall.isRunning ? <ToolCallContentBox content={toolCall.results} /> : null,
    },
  ];

  return (
    <ToolCallContainer
      toolName={toolCall.name}
      title={title}
      isRunning={toolCall.isRunning}
      tabs={tabs}
    />
  );
}
